import React,{Component} from 'react';
import {  Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

// import {
//   AppAside,
//   AppFooter,
//   AppHeader,
//   AppSidebar,
//   AppSidebarFooter,
//   AppSidebarForm,
//   AppSidebarHeader,
//   AppSidebarMinimizer,
//   AppBreadcrumb2 as AppBreadcrumb,
//   AppSidebarNav2 as AppSidebarNav,
// } from '@coreui/react';

import {
  AppBreadcrumb2 as AppBreadcrumb,
  AppFooter,
  AppHeader,
} from '@coreui/react';

// sidebar nav config
// import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import Spinner from "../../components/Spinner/Spinner";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import './Style.css'
import * as router from "react-router-dom";

import DefaultHeader from './HostHeader'
import Cookies from "js-cookie";
import * as routeConstants from "../../const/route/Route";

// const DefaultAside = React.lazy(() => import('../DefaultLayout/DefaultAside'));
// const DefaultFooter = React.lazy(() => import('./ReceptionFooter'));
// const DefaultHeader = React.lazy(() => import('./ReceptionHeader'));

class DefaultLayout extends Component {

  loading = () =>  <span />;

  signOut(e) {
    e.preventDefault();
    Cookies.remove("9b8558ba3f051677daf36ebfc67f29fa");
    Cookies.remove("3c8bed3b2d6ba6d3076ee8d2f588a4dx");
    this.props.history.push(`${routeConstants.HOST_ROUTE_PATH}/login`);
  }

  componentDidMount(){
    document.title = "VisitorTags";
    // call all building
    // this.props.callAllBuildings(this.props.usr_obj);
    // call all wifi packages
    // this.props.callAllWifiPackages(this.props.usr_obj);
    // call get all counts
  }

  render() {
    return (
      <div className="app">
        <AppHeader fixed>

          <DefaultHeader onLogout={e=>this.signOut(e)}/>

        </AppHeader>
        <div className="app-body">
          <main className="main recept" style={{marginLeft:'0px!important'}}>

            <Container fluid>

              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={props => (
                        <route.component route_name={route.name} {...props} />

                      )} />
                  ) : (null);
                })}
                {/*<Redirect from="/" to="/login" />*/}
              </Switch>

            </Container>
          </main>
          {/*<AppAside fixed>*/}

          {/*<DefaultAside />*/}

          {/*</AppAside>*/}
        </div>
        <AppFooter className={"footer-recept"}>

          <span className="ml-auto" ><a>VisitorTags</a> &copy; 2023</span>
          <span className="ml-auto" style={{fontSize:'13px'}}>Solution partner <a target="_blank" href={"https://ceyentra.com/"} style={{textDecoration:'none',color:'#1f1f1f!important'}}>Ceyentra Technologies</a></span>

        </AppFooter>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user
});

const mapDispatchToProps = (dispatch) => {
  return {


    callAllBuildings : (data) => dispatch(actionCreator.callAllBuildings(data)), // Get All Buildings Of Corporate
    callAllWifiPackages : (data) => dispatch(actionCreator.callAllWifiPackages(data)), // Get All Wifi Packges Of Corporate
    callAllCount : (data) => dispatch(actionCreator.callAllCount(data)), // Get All counts

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // history reducer
    browserHistoryHandler: (data) => dispatch(actionCreator.browserHistoryHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultLayout);
